import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { useEffect, useState } from 'react'
import { reportService } from '../services/reportService'
import { ReportSellersParams } from '../services/reportService/reportSellers'
import { startOfMonth, endOfMonth } from 'date-fns'

export const useReportSellers = () => {
  const [params, setParams] = useState<ReportSellersParams | undefined>({
    startDate: startOfMonth(new Date()).toISOString(),
    endDate: endOfMonth(new Date()).toISOString(),
  })
  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['reportSellers', params],
    queryFn: async () => reportService.reportSellers(params),
    placeholderData: keepPreviousData,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
    setParams,
    params,
  }
}
